<template>
  <div class="hs-tab" :style="{height: height}" :type="type">
    <div
      class="item"
      :type="language"
      :class="{'item-active': currentIndex === index}"
      :style="type === 'card' ? {'width': `${100 / options.length}%`} : ''"
      v-for="(item, index) in options" :key="index"
      @click="_select(index)" >
      <span :ref="`HsTab${index}`" v-html="item"></span>
    </div>
    <div class="slider-bar" :style="{transform: `translateX(${left})`, width: type === 'card' && sliderBarWidth}"></div>
  </div>
</template>
<script type="text/ecmascript-6">
export default {
  props: {
    options: {
      type: Array,
      default: function() {
        return []
      },
      required: true
    },
    selectedIndex: {
      type: Number,
      default: 0
    },
    height: {
      type: String,
      default: '40px'
    },
    type: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      currentIndex: this.selectedIndex,
      sliderBarWidth: `${100 / this.options.length}%`,
      left: `translateX(${100 * this.currentIndex}%)`
    }
  },
  watch: {
    selectedIndex(val) {
      this._select(val)
    }
  },
  methods: {
    _select(index) {
      this.currentIndex = index
      if (this.$refs[`HsTab${index}`] && this.$refs[`HsTab${index}`][0]) {
        let clientWidth = this.$refs[`HsTab${index}`][0].clientWidth
        if (this.type === 'card') {
          this.sliderBarWidth = `${100 / this.options.length}%`
        }
        this.sliderBarWidth = clientWidth + 'px'
        this.left = this.$refs[`HsTab${index}`][0].offsetLeft + (clientWidth - 18) / 2 + 'px'
      }
      this.$emit('select', index)
    }
  },
  mounted() {
    this._select(this.selectedIndex)
  }
}
</script>
<style scoped lang="stylus" rel="stylesheet/stylus">
@import '~common/stylus/base'
@import '~common/stylus/variable'
.hs-tab
  @extend .flex-row
  @extend .flex-start
  width 100%
  position relative
  overflow auto
  &[type="card"]
    background $color_black_20
    border-radius 4px
    >.item
      @extend .hs-font-caption-1
      @extend .flex-center
      color $color_black_100
      padding 2px
      margin-right 0
      &::after
        display none
      >span
        @extend .flex-center
        width 100%
        height 100%
    >.item-active
      color $color_black_900
      >span
        background-color $color_black_0
        box-shadow 0 1.5px 4px -1px rgba(44, 3, 3, 0.08)
        border-radius 4px
        font-weight 500
    >.slider-bar
      display none
  >.item
    @extend .flex-center
    @extend .no-wrap
    @extend .hs-font-subtitle-big
    flex-direction column
    height 100%
    color $color_black_200
    padding 8px 0
    text-align center
    margin-right 16px
    &::after
      display flex
      content ' '
      height 4px
      opacity 0
  >.item[type="EN"],>.item[type="JAP"]
    font-size 0.8rem
  >.item-active
    @extend .hs-font-subtitle-big
    color $color_black_900
  >.slider-bar
    position absolute
    left 0
    bottom 8px
    transition all 300ms
    display flex
    &::before,&::after
      display flex
      content ' '
      width 4px
      height 4px
      background $color_orange_300
      border-radius 50vmin
    &::after
      width 16px
      background $color_theme_300
      margin-left 2px
</style>
